import React from 'react';
import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Area = styled.div`
  display: flex;
  justify-content: center;
  height: ${vw(83)};
  margin-top: ${vw(170)};
`;

const Select = styled.select`
  width: ${vw(214)};
  height: 100%;
  background-color: #ffffff;
  margin: 0 ${vw(8)};
  padding: 0 ${vw(15)};
  border: 1px solid #dcdcde;
  border-radius: ${vw(10)};
  font-size: ${vw(28)};
`;

const BigSelect = styled.select`
  width: ${vw(673)};
  height: ${vw(83)};
  background-color: #ffffff;
  margin: ${vw(23)} ${vw(7)} 0;
  padding: 0 ${vw(15)};
  border: 1px solid #dcdcde;
  border-radius: ${vw(10)};
  font-size: ${vw(28)};
`;

function Options(props) {
  return props.list.map(item => (
    <option key={item} value={item}>
      {item}
    </option>
  ));
}

const AreaPicker = props => {
  const [provinceVal, cityVal, regionVal, areaVal] = props.value;
  const { provinceData, cityData, regionData } = props.data;

  return (
    <Wrap>
      <Area>
        <Select
          value={provinceVal}
          onChange={e => {
            const { value } = e.target;
            props.onChange({
              value: [value, '', '', ''],
              data: { provinceData, cityData: [], regionData: [] },
              next: 'cityData',
              name: '省份'
            });
          }}
        >
          <option value="">选择省份</option>
          <Options list={provinceData} />
        </Select>
        <Select
          value={cityVal}
          onChange={e => {
            const { value } = e.target;
            props.onChange({
              value: [provinceVal, value, '', ''],
              data: { provinceData, cityData, regionData: [] },
              next: 'regionData',
              name: '城市'
            });
          }}
        >
          <option value="">选择城市</option>
          <Options list={cityData} />
        </Select>
        <Select
          value={regionVal}
          onChange={e => {
            const { value } = e.target;
            props.onChange({
              value: [provinceVal, cityVal, value, ''],
              data: { provinceData, cityData, regionData },
              next: 'area',
              name: '区县'
            });
          }}
        >
          <option value="">选择区县</option>
          <Options list={regionData} />
        </Select>
      </Area>
      <BigSelect
        value={areaVal}
        onChange={e => {
          const { value } = e.target;
          props.onChange({
            value: [provinceVal, cityVal, regionVal, value.name],
            info: { ...JSON.parse(value) },
            name: '网点'
          });
        }}
      >
        <option value="">请选择附近的中行网点</option>
        {props.areaInfo.map((item, index) => (
          <option key={index} value={JSON.stringify(item)}>
            {item.name}
          </option>
        ))}
      </BigSelect>
    </Wrap>
  );
};

export default AreaPicker;
